import React from "react";
import { themeStyleSheet } from "../../../constants";
import { CircularProgress } from "@mui/material";
import Icon from "../../../assets/Icon";
import LineText from "../../../Libraries/LineText";

const { innerHeight } = window;

const CustomButton = ({
  prefix,
  className,
  disabled,
  onClick,
  style,
  type,
  status,
  title,
  loading,
  onAction,
  width,
  suffix,
  suffixIcon,
  isComingSoon = false,
  id,
}) => {
  if (type === "primary") {
    return (
      <div
        className="customerSaveBtnMain customerProfileCont"
        style={{ height: innerHeight * 0.13 }}
      >
        <button
          type="submit"
          id={id}
          className="customerSaveBtn"
          style={{
            background: status
              ? themeStyleSheet.brightGreen
              : themeStyleSheet.white,
            color: status ? themeStyleSheet.white : themeStyleSheet.lightGray,
            width: width,
          }}
          disabled={status || !loading ? false : true}
        >
          {loading ? (
            <CircularProgress className="loaderCircle" color="inherit" />
          ) : (
            title.toUpperCase()
          )}
        </button>
      </div>
    );
  } else if (type === "in") {
    return (
      <div
        id="creditHIstoryTakeButton"
        className="takeButton"
        onClick={onAction}
      >
        <span className="takeButtonIcon">
          <svg
            fill="#fff"
            height="26"
            width="26"
            viewBox="0 0 45 45"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#fff"
              d="M27.529,13.772v18.557l4.801-4.802c0.791-0.791,2.078-0.791,2.869,0c0.396,0.396,0.594,0.938,0.594,1.437
                                        c0,0.543-0.197,1.039-0.594,1.435l-8.264,8.265c-0.396,0.396-0.893,0.596-1.438,0.596c-0.543,0-1.039-0.198-1.434-0.596L15.8,30.398
                                        c-0.793-0.791-0.793-2.078,0-2.868c0.791-0.791,2.078-0.791,2.869,0l4.801,4.801V13.772c0-1.139,0.891-2.029,2.027-2.029
                                        C26.639,11.743,27.529,12.634,27.529,13.772z"
            />
          </svg>
        </span>
        <span
          className={"takeButtonText"}
          style={{
            fontSize: "0.9rem",
            //   textAlign: type === "bill" ? "right" : "",
          }}
        >
          {title}
        </span>
      </div>
    );
  } else if (type === "out") {
    return (
      <div
        id="creditHIstoryGiveButton"
        className="giveButton"
        onClick={onAction}
      >
        <span className={"giveButtonText"} style={{ fontSize: "0.9rem" }}>
          {title}
        </span>

        <span className="giveButtonIcon">
          <svg
            fill="#fff"
            height="26"
            width="26"
            viewBox="0 0 45 45"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#fff"
              d="M23.471,37.229V18.671l-4.801,4.801c-0.791,0.791-2.078,0.791-2.869,0c-0.396-0.396-0.594-0.939-0.594-1.436
  c0-0.543,0.197-1.039,0.594-1.434l8.264-8.264c0.396-0.396,0.891-0.596,1.436-0.596c0.543,0,1.039,0.199,1.435,0.596l8.265,8.264
  c0.793,0.791,0.793,2.078,0,2.869c-0.791,0.791-2.078,0.791-2.869,0l-4.802-4.801v18.557c0,1.141-0.891,2.029-2.026,2.029
  C24.362,39.257,23.471,38.366,23.471,37.229z"
            />
          </svg>
        </span>
      </div>
    );
  } else if (type === "secondary") {
    return (
      <div
        className="crtBusinessBtnMain saveBtnCircle"
        style={{ height: innerHeight * 0.13 }}
      >
        <button
          type="submit"
          id={id}
          className="crtBusinessBtn"
          style={{
            background: status
              ? themeStyleSheet.brightGreen
              : themeStyleSheet.white,
            color: status ? themeStyleSheet.white : themeStyleSheet.lightGray,
            width: width,
          }}
          disabled={status || !loading ? false : true}
        >
          <span>
            {!loading ? (
              <svg
                fill={status ? "#fff" : "#CECECE"}
                height="26"
                width="26"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                {status ? (
                  <path
                    fill=""
                    d="M42.623,24.197l-15.834-0.001L26.785,8.365c0-0.319-0.141-0.646-0.389-0.894
                              c-0.479-0.478-1.348-0.477-1.812-0.015c-0.243,0.243-0.378,0.565-0.378,0.908v15.828H8.383c-0.709,0.002-1.287,0.58-1.285,1.288
                              c0,0.688,0.6,1.292,1.285,1.292l15.828,0.002L24.213,42.6c-0.002,0.32,0.14,0.646,0.387,0.896c0.25,0.251,0.578,0.396,0.9,0.396
                              h0.002c0.707,0,1.283-0.58,1.285-1.291l-0.002-15.824h15.83c0.344,0,0.666-0.135,0.908-0.377c0.244-0.244,0.379-0.567,0.379-0.914
                              C43.9,24.822,43.279,24.197,42.623,24.197z"
                  />
                ) : (
                  <path
                    fill=""
                    d="M42.623,24.197l-15.834-0.001L26.785,8.365c0-0.319-0.141-0.646-0.389-0.894
                                c-0.479-0.478-1.348-0.477-1.812-0.015c-0.243,0.243-0.378,0.565-0.378,0.908v15.828H8.383c-0.709,0.002-1.287,0.58-1.285,1.288
                                c0,0.688,0.6,1.292,1.285,1.292l15.828,0.002L24.213,42.6c-0.002,0.32,0.14,0.646,0.387,0.896c0.25,0.251,0.578,0.396,0.9,0.396
                                h0.002c0.707,0,1.283-0.58,1.285-1.291l-0.002-15.824h15.83c0.344,0,0.666-0.135,0.908-0.377c0.244-0.244,0.379-0.567,0.379-0.914
                                C43.9,24.822,43.279,24.197,42.623,24.197z"
                  />
                )}
              </svg>
            ) : (
              <CircularProgress className="loaderCircle" color="inherit" />
            )}
          </span>
          <span
            style={{
              color: status ? themeStyleSheet.white : themeStyleSheet.lightGray,
              marginLeft: 5,
            }}
          >
            {title}
          </span>
        </button>
      </div>
    );
  } else if (type === "roundedButton") {
    return (
      <button
        id={id}
        className={`roundedbtn ${className}`}
        disabled={disabled || loading}
        onClick={onClick}
        style={style}
      >
        {loading ? (
          <CircularProgress className="loaderCircle" color="inherit" />
        ) : (
          <span>{title}</span>
        )}
      </button>
    );
  } else if (type === "primary-new") {
    return (
      <>
        {isComingSoon ? (
          <LineText className="coming_soon_label">Coming Soon</LineText>
        ) : (
          <></>
        )}
        <button
          className={`customerSaveBtn ${className}`}
          disabled={disabled || loading}
          onClick={onClick}
          style={style}
          id={id || ""}
        >
          {loading ? (
            <CircularProgress className="loaderCircle" color="inherit" />
          ) : (
            <>
              <span>{title || ""}</span>
              {prefix ? <Icon data={prefix} /> : null}
            </>
          )}
        </button>
      </>
    );
  } else if (type === "primary-new-suffix") {
    return (
      <button
        className={`customerSaveBtn ${className}`}
        disabled={disabled || loading}
        onClick={onClick}
        style={style}
        id={id || ""}
      >
        {loading ? (
          <CircularProgress className="loaderCircle" color="inherit" />
        ) : (
          <>
            {suffix ? suffix : suffixIcon ? <i className={`${suffixIcon}`}></i> : null}
            <span>{title || ""}</span>
          </>
        )}
      </button>
    );
  } else if (type === "primary-input") {
    return (
      <>
        <button
          id={id}
          className={`customerSaveBtn cursorPointer selectFile ${className}`}
          style={style}
        >
          <span>{title || ""}</span>
          {prefix ? (
            <span>
              <Icon data={prefix} />
            </span>
          ) : null}
          <input
            accept=".jpeg, .png, .jpg, .zip"
            onChange={onClick}
            name="image"
            type="file"
          />
        </button>
      </>
    );
  }
};

export default CustomButton;
